// extracted by mini-css-extract-plugin
module.exports = {"button":"_2fa5418"};